'use client'

import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion'
import { ChevronDownIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * Дэлгэгддэг жагсаалт.
 *
 * `ui/collapsible.tsx`-тэй ижил хэв маягаар base-ui дээр бичив — төслийн бусад
 * примитивүүд адилхан «Root-ыг ороож `data-slot` өгөх» загвартай.
 *
 * Өндрийн шилжилтийг base-ui-ийн `--accordion-panel-height` хувьсагчаар хийнэ;
 * гар аргаар өндөр хэмжих шаардлагагүй.
 */
function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
  return <AccordionPrimitive.Root data-slot='accordion' className={cn('flex flex-col', className)} {...props} />
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
  return <AccordionPrimitive.Item data-slot='accordion-item' className={cn('border-b', className)} {...props} />
}

function AccordionTrigger({ className, children, ...props }: AccordionPrimitive.Trigger.Props) {
  return (
    <AccordionPrimitive.Header className='flex'>
      <AccordionPrimitive.Trigger
        data-slot='accordion-trigger'
        className={cn(
          'group flex flex-1 cursor-pointer items-start justify-between gap-4 py-4 text-left font-medium transition-colors',
          'hover:text-muted-foreground focus-visible:outline-2 focus-visible:outline-offset-2',
          className
        )}
        {...props}
      >
        {children}
        <ChevronDownIcon className='text-muted-foreground mt-0.5 size-5 shrink-0 transition-transform duration-200 group-data-[panel-open]:rotate-180' />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionContent({ className, children, ...props }: AccordionPrimitive.Panel.Props) {
  return (
    <AccordionPrimitive.Panel
      data-slot='accordion-content'
      className='h-(--accordion-panel-height) overflow-hidden transition-[height] duration-250 ease-out data-ending-style:h-0 data-starting-style:h-0'
      {...props}
    >
      <div className={cn('pb-4', className)}>{children}</div>
    </AccordionPrimitive.Panel>
  )
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
